// extracted by mini-css-extract-plugin
export default {"resetMargin":"X_DqR"};